export const namespace = 'searchCondition';
export const SAVE_ORDER_SEARCH_CONDITION = `${namespace}/saveOrderSearchCondition`;
export const SAVE_PRODUCT_SEARCH_CONDITION = `${namespace}/saveProductSearchCondition`;
export const SAVE_BLOG_SEARCH_CONDITION = `${namespace}/saveBlogSearchCondition`;
